<div *ngIf="!asBadge" [ngClass]="{ 'd-inline': shouldBeInline }">
    <div class="status-box status-box--large "
         [ngClass]="colorClass"
         [placement]="showLabel ? 'left' : 'right'"
         ngbTooltip="{{variant ? 'IDA Lagerstatus' : 'Status'}}: {{label}}">
    </div>
    <ng-container *ngIf="showLabel">
        <span [ngClass]="{'status-box-label__alternate': variant}">
            {{label}}
    </span>
    </ng-container>
</div>
<ng-container *ngIf="asBadge">
    <span class="badge rounded-pill" [ngClass]="colorClass">{{label}}</span>
</ng-container>
